import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FollowerService } from '@sparro/app/core/api/follower/follower.service';
import { Publication } from '@sparro/app/core/models/publication.model';
import { User } from '@sparro/app/core/models/user.model';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-publication-panel',
  templateUrl: './publication-panel.component.html',
  styleUrls: ['./publication-panel.component.scss']
})

export class PublicationPanelComponent implements OnInit {
  @Input() publication: Publication;
  @Input() showUser: boolean = false;
  @Input() user: User;
  @Output() metaSectionTop = new EventEmitter;
  self: boolean = false;
  isScriptLoaded: boolean = true;

  @ViewChild('shareContainer') container: ElementRef;
  constructor(
    private followerService: FollowerService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
   }
  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.publication?.author?.username === this.user?.username) {
      this.self = true;
    }
    if (this.container) {
      this.metaSectionTop.emit(this.container.nativeElement.offsetTop);
    }
  }

  toggleUserFollow(): void {
    if (this.publication.author.is_following) {
      this.followerService.unfollow('users', this.publication.author.username, this.publication.author.is_following?.id).subscribe(
        (response) => {
          if (response) {
            this.publication.author.is_following = null;
            this.changeDetectorRef.detectChanges();
          }
        });
    } else {
    const data = {
      follower: this.user.id
    };
    this.followerService.follow('users', this.publication.author.username, data).subscribe(
      (response: any) => {
        this.changeDetectorRef.detectChanges();
        this.publication.author.is_following = response;
      },
      (err) => {
        console.log(err);
      });
    }
  }
  goToTopic(slug: string): string {
    return `${environment.topicUrl}${slug}`;
  }

  getProfileUrl(user: User): string {
    return `${environment.profileUrl}${user.username}/`;
  }
}
